'use strict';

import Vue from 'vue';
import { logger } from '@/logging';


export const fetchAll = async ({ dispatch, commit }) => {
	await dispatch('find');
	commit('setReady');
};


//=============================================================================
//=========================== Action Edit Dialog ==============================
//=============================================================================


export const createAction = ({ commit }) => {
	const { Action } = Vue.$FeathersVuex;
	const copy = new Action({});

	commit('setEditCopy', copy);
	commit('showEditDialog');
};

//=================================================================================================================

export const editAction = ({ commit }, { item }) => {
	commit('setEditCopy', item.clone());
	commit('showEditDialog');
};

//=================================================================================================================

export const saveAction = async ({ commit }, { item }) => {
	try {
		await item.save();

		commit('hideEditDialog');
		commit('clearEditCopy');
	}
	catch(err) {
		logger.get('actions').error('Error when saving action', err);
		throw err;
	}
};

//=================================================================================================================

export const cancelActionChanges = ({ commit }, { item }) => {
	commit('hideEditDialog');
	commit('clearEditCopy');
	item.id && item.reset();
};

//=================================================================================================================

export const deleteAction = async (context, { item }) => {
	try {
		return item.remove();
	}
	catch(err) {
		logger.get('actions').error('Error when deleting action', err);
		throw err;
	}
};

//=================================================================================================================

export const clearErrors = ({ commit })=> {
	commit('clearCreateError');
	commit('clearPatchError');
	commit('clearRemoveError');
};
